import { useSyncExternalStore } from 'react';
import { sqlCaptureSetting } from 'utils/sql-capture-setting';

export default function useSqlCaptureEnabled(): boolean {
  return useSyncExternalStore(
    sqlCaptureSetting.subscribe,
    sqlCaptureSetting.isEnabled
  );
}
